<template>
  <div>
    <v-dialog v-model="model" max-width="1200" persistent scrollable>
      <material-card
        :title="$t('components.claims.provider_dialog.add_provider')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        v-if="provider"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{
                          $t(
                            "components.claims.provider_dialog.provider_information"
                          )
                        }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container fill-height fluid>
                    <v-row wrap>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          v-model="provider.FirstName"
                          :label="$t('globals.firstname')"
                          :rules="[$rules.required, $rules.validName]"
                          class="required"
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          v-model="provider.MiddleName"
                          :label="
                            $t('globals.middlename')
                          "
                          :rules="[$rules.validName]"
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          v-model="provider.LastName"
                          :label="$t('globals.lastname')"
                          :rules="[$rules.required, $rules.validName]"
                          class="required"
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <no-autocomplete-textfield
                          v-model="provider.UniqueId"
                          :label="
                            $t('components.claims.provider_dialog.unique_id')
                          "
                          :rules="uniqueRules"
                          class="required"
                        ></no-autocomplete-textfield>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <trans-select
                          clearable
                          :item="provider"
                          propertyName="LanguageChoice"
                          :items="options.Models.LanguageChoice"
                          :label="
                            $t('headers.members_management.LanguageChoice')
                          "
                        ></trans-select>
                      </div>
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <trans-enum
                          :value.sync="provider.ProviderType"
                          :items="options.Enums.Coverage"
                          :label="
                            $t(
                              'components.claims.provider_dialog.provider_type'
                            )
                          "
                          :rules="[$rules.required]"
                          class="required"
                          :disabled="type !== null && type != undefined"
                        ></trans-enum>
                      </div>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{
                          $t(
                            "components.claims.provider_dialog.office_information"
                          )
                        }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container fill-height fluid>
                    <v-row>
                      <v-col>
                        <v-btn
                          style="margin-left: 5px"
                          color="success"
                          dark
                          @click="addProviderOffice"
                        >
                          <v-icon>add</v-icon>
                          {{ $t("globals.add_new") }}
                        </v-btn>
                      </v-col>
                      <v-col v-if="selected !== null && selected !== undefined">
                        <v-btn
                          style="margin-left: 25px"
                          color="primary"
                          dark
                          @click="editProviderOffice"
                        >
                          <v-icon>edit</v-icon>
                          {{ $t("globals.edit") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <div class="col-12 col-xs-12">
                        <DualListBoxSingleSelect
                          ref="offices"
                          :source="offices"
                          :destination="provider.ProviderOffices"
                          :displayFunc1="
                            (item) => `${formatDrawbridgeAddress(item.Address)}`
                          "
                          :displayFunc2="
                            (item) =>
                              `${formatDrawbridgeAddress(item.Office.Address)}`
                          "
                          @selected="selected = $event"
                          @add-destination="onAddOffice"
                          @add-source="onRemoveOffice"
                        />
                      </div>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              provider = null;
              $emit('close');
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="save"
            :disabled="!valid || provider.ProviderOffices.length === 0"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <provider-office-dialog
      :model="providerOfficeDialog"
      :providerOffice="providerOffice"
      :title="providerOfficeTitle"
      @close="providerOfficeDialog = false"
      @save="saveProviderOffice"
    />
    <v-dialog
      v-model="removeProviderOfficeDialog"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="
          $t('components.claims.provider_dialog.remove_office_from_provider')
        "
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color text @click="removeProviderOfficeDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="removeProviderOffice">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import TransEnum from "../TransEnum.vue";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import TransSelect from "../TransSelect.vue";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import DualListBoxSingleSelect from "../DualListboxSingleSelect.vue";
import ProviderOfficeDialog from "@/components/Claims/ProviderOfficeDialog.vue";
import { translate } from "@/trans";

export default {
  components: {
    ErrorHandler,
    TransEnum,
    NoAutocompleteTextfield,
    TransSelect,
    DualListBoxSingleSelect,
    ProviderOfficeDialog,
  },
  props: ["model", "type", "item"],
  directives: { mask },
  data() {
    return {
      error: null,
      saving: false,
      valid: false,
      provider: null,
      offices: [],
      selected: null,
      telephoneMask: "(###) ### - ####",
      providerOfficeDialog: false,
      providerOffice: null,
      removeProviderOfficeDialog: false,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language", "settings"]),
    providerOfficeTitle() {
      // console.log(this.provider);
      if (this.provider === null || this.provider === undefined) {
        return this.$t(
          "components.claims.provider_dialog.add_office_to_provider_{0}",
          [""]
        );
      }
      return this.$t(
        "components.claims.provider_dialog.add_office_to_provider_{0}",
        [`${this.provider.FirstName} ${this.provider.LastName}`]
      );
    },
    uniqueRules() {
      if (this.provider.ProviderType === "Dental") {
        return [
          this.$rules.required,
          this.$rules.numericString,
          this.$rules.dynamic.length(9),
        ];
      }
      return [this.$rules.required, this.$rules.alphanumeric,];
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          if (this.item) {
            this.provider = JSON.parse(JSON.stringify(this.item));
            for (const providerOffice of this.provider.ProviderOffices) {
              providerOffice.Office.Address = this.createAddressFromOffice(
                providerOffice.Office
              );
              providerOffice.Identifier =
                providerOffice.ProviderId + providerOffice.OfficeId;
            }
            console.log(this.provider);
          } else {
            this.provider = {
              Identifier: Math.random().toString(),
              ProviderOffices: [],
              ProviderType: this.type,
            };
          }
        } else {
          this.provider = null;
        }
      },
    },
    item: {
      handler(v) {
        if (v) {
          this.provider = JSON.parse(JSON.stringify(v));
          for (const providerOffice of this.provider.ProviderOffices) {
            providerOffice.Office.Address = this.createAddressFromOffice(
              providerOffice.Office
            );
            providerOffice.Identifier =
              providerOffice.ProviderId + providerOffice.OfficeId;
          }
          console.log(this.provider);
        } else {
          this.provider = {
            Identifier: Math.random().toString(),
            ProviderOffices: [],
            ProviderType: this.type,
          };
        }
      },
    },
  },
  mounted() {
    // this.provider = {
    //   Identifier: Math.random().toString(),
    //   ProviderOffices: [],
    // };
    if (this.item) {
      this.provider = JSON.parse(JSON.stringify(this.item));
      for (const providerOffice of this.provider.ProviderOffices) {
        providerOffice.Office.Address = this.createAddressFromOffice(
          providerOffice.Office
        );

        providerOffice.Identifier =
          providerOffice.ProviderId + providerOffice.OfficeId;
      }
      console.log(this.provider);
    } else {
      this.provider = {
        Identifier: Math.random().toString(),
        ProviderOffices: [],
        ProviderType: this.type,
      };
    }
  },
  methods: {
    ...mapActions("claims", ["newProvider", "updateProvider"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async save() {
      // console.log(this.provider);
      let provider = JSON.parse(JSON.stringify(this.provider));
      if (provider.LanguageChoice) {
        provider.LanguageChoiceId = provider.LanguageChoice.Id;
        delete provider.LanguageChoice;
      }
      for (let office of provider.ProviderOffices) {
        if (office.WorkPhone !== null && office.WorkPhone !== undefined) {
          office.WorkPhone = this.unmask(office.WorkPhone, this.telephoneMask);
        }
        if (office.Fax !== null && office.Fax !== undefined) {
          office.Fax = this.unmask(office.Fax, this.telephoneMask);
        }
        office.Office.City = office.Office.Address.City;
        office.Office.Province = this.options.Models.Province.filter(
          (o) => o.Id === (office.Office.Address.ProvinceId ? office.Office.Address.ProvinceId : office.Office.Address.Province.Id)
        )[0].Code;//office.Office.Address.Province.Code;
        office.Office.PostalCode = office.Office.Address.PostalCode;
        office.Office.Address1 = this.generateAddressLine1(
          office.Office.Address
        );
        delete office.Office.Address;
      }

      try {
        this.saving = true;
        if (this.item) {
          await this.updateProvider({
            providerId: this.item.Id,
            payload: provider,
          });
          this.$emit("saved", provider);
        } else {
          await this.newProvider({
            payload: provider,
          });
          this.$emit("saved", provider);
        }

        this.provider = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    generateAddressLine1(address) {
      if (address.Address1) {
        return address.Address1;
      }
      var res = "";
      if (address.SuiteNumber) res += address.SuiteNumber;
      if (address.StreetNumber) {
        if (res.length > 0) res += " ";
        res += address.StreetNumber.toString();
      }
      if (address.StreetName) {
        if (res.length > 0) res += ", ";
        res += address.StreetName;
      }
      return res;
    },
    onAddOffice: async function({ selected }) {
      let newOffice = selected[0];
      this.providerOffice = {
        Office: newOffice,
        Identifier: Math.random().toString(),
      };
      this.providerOfficeDialog = true;
    },
    onRemoveOffice: async function({ selected }) {
      this.providerOffice = JSON.parse(JSON.stringify(selected[0]));
      this.removeProviderOfficeDialog = true;
    },
    removeProviderOffice() {
      let existing = this.offices.filter(
        (o) => o.Identifier === this.providerOffice.Office.Identifier
      );
      if (existing.length > 0) {
        this.offices[this.offices.indexOf(existing[0])] = JSON.parse(
          JSON.stringify(this.providerOffice.Office)
        );
      } else {
        this.offices.push(
          JSON.parse(JSON.stringify(this.providerOffice.Office))
        );
      }
      this.provider.ProviderOffices = this.provider.ProviderOffices.filter(
        (p) => p.Identifier !== this.providerOffice.Identifier
      );

      this.closeProviderOffice();
    },
    closeProviderOffice() {
      this.providerOffice = null;
      this.selected = null;
      // if (this.$refs.planOfficeForm)
      //   this.$refs.planOfficeForm.resetValidation();
      this.providerOfficeDialog = false;
      this.removeProviderOfficeDialog = false;
      // this.$emit("valid", this.internalPlanInsuranceCarriers.length > 0);
      this.$forceUpdate();
    },
    providerOfficeValid() {
      if (!this.providerOffice) return false;
      return this.valid.providerOffice && this.valid.policy;
    },
    addProviderOffice() {
      this.providerOffice = {
        Office: { Identifier: Math.random().toString() },
        Identifier: Math.random().toString(),
      };
      this.providerOfficeDialog = true;
    },
    editProviderOffice() {
      // console.log(this.selected);
      this.providerOffice = JSON.parse(JSON.stringify(this.selected));
      this.providerOfficeDialog = true;
    },
    saveProviderOffice() {
      this.providerOffice.selected = false;
      let existing = this.provider.ProviderOffices.filter(
        (o) => o.Identifier === this.providerOffice.Identifier
      );
      // console.log(
      //   JSON.stringify(existing),
      //   JSON.stringify(this.providerOffice)
      // );
      if (existing.length > 0) {
        const index = this.provider.ProviderOffices.indexOf(existing[0]);
        // console.log(index);
        this.provider.ProviderOffices[index] = JSON.parse(
          JSON.stringify(this.providerOffice)
        );
      } else {
        this.provider.ProviderOffices.push(
          JSON.parse(JSON.stringify(this.providerOffice))
        );
      }
      this.offices = this.offices.filter(
        (o) => o.Identifier !== this.providerOffice.Office.Identifier
      );
      // console.log(this.providerOffices, this.offices);
      this.closeProviderOffice();
      this.$refs.offices.updateDestination(this.provider.ProviderOffices);
    },
    formatDrawbridgeAddress(address) {
      console.log(address);
      var res = "";
      if (address) {
        if (address.Address1) {
          res += address.Address1 + "\n";
          if (address.Address2) {
            res += address.Address2 + "\n";
            if (address.Address3) {
              res += address.Address3 + "\n";
            }
          }
        } else {
          if (address.SuiteNumber) res += address.SuiteNumber;
          if (address.StreetNumber) {
            if (res.length > 0) res += " ";
            res += address.StreetNumber.toString();
          }
          if (address.StreetName) {
            if (res.length > 0) res += ", ";
            res += address.StreetName;
          }
        }

        if (address.City) {
          if (res.length > 0) res += "\n";
          res += address.City;
        }
        if (address.Province) {
          if (res.length > 0) res += ", ";
          res += address.Province.Code;
        }

        if (address.PostalCode) res += " " + address.PostalCode;
        if (address.Country)
          res += "\n " + translate(address.Country, this.language.language);
      }
      return res;
    },
    createAddressFromOffice(office) {
      return {
        Address1: office.Address1,
        Address2: office.Address2,
        Address3: office.Address3,
        City: office.City,
        Province: office.Province,
        PostalCode: office.PostalCode,
        Country: office.Country,
      };
    },
    formatAddress(item) {
      console.log(item);
      var res = "";
      if (item) {
        if (item.Address1) {
          res += item.Address1 + "\n";
          if (item.Address2) {
            res += item.Address2 + "\n";
            if (item.Address3) {
              res += item.Address3 + "\n";
            }
          }
        }
        if (item.City) {
          if (res.length > 0) res += "\n";
          res += item.City;
        }
        if (item.Province) {
          if (res.length > 0) res += ", ";
          res += item.Province.Code;
        }

        if (item.PostalCode) res += " " + item.PostalCode;
        if (item.Country)
          res += "\n " + translate(item.Country, this.language.language);
      }
      return res;
    },
  },
};
</script>
